import { useAccountsItems, useAppSelector } from '@pkg/hooks';

import { useProfileLinks } from '@app/store/zustand';
import { useGetWishlists } from '@app/store/zustand/wishlists/useGetWishlist';

import { useIsPreview } from './useIsPreview';

export const usePrefetchSections = () => {
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const yatsSectionEnabled = useAppSelector((state) => state.featureFlags.features.yatsPortfolio);
    const userId = useAppSelector((state) => state.yatPage.user_id) || '';
    const isPreview = useIsPreview();

    const eid = useAppSelector((state) => state.yatPage.eid);

    const { data: linksData, isPending: linksPending } = useProfileLinks(eid);
    const { data: accData, isLoading: isLoadingItems } = useAccountsItems({ pageOwnerId: userId });
    const itemCount = accData?.pagesData?.flatMap((account) => account?.collectibles)?.length;

    const { data: wishlistData, isLoading: isLoadingWishlists } = useGetWishlists({
        limit: 10,
        variables: {
            filter: {
                owned: {
                    internalId: userId,
                    primaryYat: '',
                },
            },
        },
    });

    const isLoading = !eid || !userId || isLoadingWishlists || isLoadingItems || linksPending;
    const privateView = isPageOwner && !isPreview;

    const wishlistsEnabled = privateView || Boolean(wishlistData?.pages?.[0].data?.wishlists?.value.length);
    const linksEnabled = privateView || Boolean(linksData?.data?.profile.links.length);

    const emptyProfile = !wishlistsEnabled && !linksEnabled && !yatsSectionEnabled;
    const nftsEnabled = privateView || Boolean(itemCount) || emptyProfile;

    return {
        isLoading,
        wishlistsEnabled,
        nftsEnabled,
        linksEnabled,
        isLoadingItems: !userId || isLoadingWishlists,
        isLoadingWishlists: !userId || isLoadingWishlists,
        isLoadingLinks: !eid || linksPending,
    };
};
